/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatSpeakIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4ElEQVR4nN1UTWsUQRBtRUXRiyD+AD+OisSLhMiectqpejUbeqpmCOS2v0DxuBfxEhH05MdRSA7xd4i/IBH8xoPgwYNIUFAivdlNOpne7OyKB20omO6peq/qVXU7918v7/0xQCuCrbLYW4JtBmPoG4aucF5Yt9s9OhV4hnKBoB9ZbGuMfWA2bgzc6/UOE/R+A+Ct2Ej0nnPu0FgCFn0wKTjvJRm9SKxIBsM+A9WlTMq5HTDYbRZ7RLCfsW+GUpLgraWl430992cF26S8uLZb4QAoK8+EPVBdCQlE/q/DcKSyL+vg+ovZ8r0SDqvS5yJ6PpxleTFDsB9RFQsp7Z8NHQCdHd0jGxJsMOxTu1Ne3E5Qn0T/VuqBYbYHDgf1iQc+8/OLJzPoDRJd25ZKZ2PyVOD3SQiccy7PF8+y6Jfw3W5Xp3enyb7WAmMN/woBTyiR9/4Ui95MSUSw9XoFoms7UyDl3DgCEnsZmkzkLzRq8jRj2u5U58KZSHU1lphEOzWCcDlI7N2kFy3Li5lGF61fBfTWqKeCyC4Dej2q4A5BH+9/KkgUSfD+RESNntKWk+De+xMk+uLPwPXuyOeaRB9ODQx9D5SUBI4at9yfmGaZfmOxVwx9yrn6Vqt15EDwf379BmVkC0HbciauAAAAAElFTkSuQmCC)
 */
export const ChatSpeakIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 22a10 10 0 1 0-8.45-4.64c.13.19.11.44-.04.61l-2.06 2.37A1 1 0 0 0 2.2 22H12Zm2-5.26c0 .61.56 1.09 1.14.87a6 6 0 0 0 0-11.22c-.58-.22-1.14.26-1.14.87v.1c0 .45.32.83.73 1.03a4 4 0 0 1 0 7.22c-.41.2-.73.58-.73 1.04v.09Zm0-3.32c0 .69.7 1.15 1.18.65a2.99 2.99 0 0 0 0-4.14c-.48-.5-1.18-.04-1.18.65v2.84ZM12 7a1 1 0 0 0-1-1h-.05a1 1 0 0 0-.75.34L7.87 9H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1.87l2.33 2.66a1 1 0 0 0 .75.34H11a1 1 0 0 0 1-1V7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
